import * as Sentry from '@sentry/react';
import { createSentryConfig } from './sentryConfig';
import { setupRouteListeners } from './routeControl';
import { BreadcrumbLevels } from '../constants/breadcrumbTypes.constants';

// Main function to initialize Sentry and set up route monitoring
export const start = (history) => {
  const currentUser = JSON.parse(localStorage.getItem('user'));

  // Initialize Sentry with modular configuration
  const config = createSentryConfig(history);
  Sentry.init(config);

  // Set up route change listeners and replay control
  setupRouteListeners(history);

  // Set user context if available
  if (currentUser) {
    Sentry.setUser({ email: currentUser.email });
  }
};

// Basic logging function
export const log = (category, message) => {
  Sentry.addBreadcrumb({
    category: category,
    message: message,
    level: 'info'
  });
};

// Advanced breadcrumb utility
export const addBreadcrumbUtil = (
  category,
  message,
  level = BreadcrumbLevels.INFO,
  data = {}
) => {
  Sentry.addBreadcrumb({
    category,
    message,
    level,
    data
  });
};

// Sentry logger object with different levels
export const sentryLogger = {
  info: (message, context = {}) => {
    addBreadcrumbUtil(
      context.entityName,
      message,
      BreadcrumbLevels.INFO,
      context
    );
  },

  warn: (message, context = {}) => {
    Sentry.addBreadcrumb({
      category: context.entityName,
      message,
      level: 'warning',
      data: context
    });
  },

  error: (message, context = {}) => {
    Sentry.withScope((scope) => {
      scope.setTag('entityName', context.entityName);
      scope.setExtras(context);
      Sentry.captureException(context.error || new Error(message));
    });
  }
};

// Re-export functions from routeControl for backward compatibility
export {
  disableReplay,
  enableReplay,
  getReplayStatus,
  isTracingDisabled,
  getTracingStatusForPath
} from './routeControl';
